import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import globalStyles from "../../global";
import { getResponsiveSize } from "../../utils/responsive";

const LaundryMan = ({ color, textColor }) => {
  const { t } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

  return (
    <Box sx={[styles.outerContainer, { backgroundColor: color }]}>
      <Box sx={styles.innerContainer}>
        <Box
          sx={[
            styles.contentRow,
            { flexDirection: { xs: "column", md: "row-reverse" } },
          ]}
        >
          <Box sx={styles.imageContainer}>
            <img
              src={`${imageBaseUrl}aboutarunabh.png`}
              alt={t("laundryMan.arunabhImageAlt")}
              style={styles.image}
            />
          </Box>
          <Box sx={styles.textContainer}>
            <Box
              sx={[styles.heading, { color: globalStyles.colors.army_green }]}
            >
              {t("laundryMan.arunabhTitle")}
            </Box>
            <Box sx={styles.descriptionContainer}>
              <Typography
                variant="regular_text_ur"
                sx={[styles.description, { whiteSpace: "pre-line" }]}
              >
                {t("laundryMan.arunabhDescription")}
              </Typography>
            </Box>
            <Box sx={styles.authorName}>{t("laundryMan.arunabhName")}</Box>
            <Box sx={styles.authorTitle}>{t("laundryMan.arunabhRole")}</Box>
          </Box>
        </Box>
      </Box>
      {/* ==== */}
      <Box sx={styles.innerContainer}>
        <Box
          sx={[
            styles.contentRow,
            { flexDirection: { xs: "column", md: "row" } },
          ]}
        >
          <Box sx={styles.imageContainer}>
            <img
              src={`${imageBaseUrl}aboutgunajan.png`}
              alt={t("laundryMan.gunjanImageAlt")}
              style={styles.image}
            />
          </Box>
          <Box
            sx={[
              styles.textContainer,
              { mt: { xs: getResponsiveSize(4), md: 0 } },
            ]}
          >
            <Box
              sx={[styles.heading, { color: globalStyles.colors.army_green }]}
            >
              {t("laundryMan.gunjanTitle")}
            </Box>
            <Box sx={styles.descriptionContainer}>
              <Typography
                variant="regular_text_ur"
                sx={[styles.description, { whiteSpace: "pre-line" }]}
              >
                {t("laundryMan.gunjanDescription")}
              </Typography>
            </Box>
            <Box sx={styles.authorName}>{t("laundryMan.gunjanName")}</Box>
            <Box sx={styles.authorTitle}>{t("laundryMan.gunjanRole")}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  outerContainer: {
    width: "100%",
    paddingBottom: { xs: getResponsiveSize(6), sm: getResponsiveSize(8) },
  },
  innerContainer: {
    width: "100%",
    maxWidth: "1200px",
    mx: "auto",
    margin: "auto",
    paddingTop: { xs: getResponsiveSize(4), sm: getResponsiveSize(6) },
  },
  contentRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: { xs: "column", md: "row" },
  },
  imageContainer: {
    width: { xs: "100%", md: "48%" },
    display: "flex",
    justifyContent: "center",
    marginBottom: { xs: getResponsiveSize(4), md: 0 },
    paddingTop: { xs: getResponsiveSize(2), md: 0 },
    overflow: "hidden",
    paddingX: { xs: getResponsiveSize(2), md: 0 },
  },
  image: {
    maxWidth: "100%",
    height: "auto",
    objectFit: "contain",
    display: "block",
  },
  textContainer: {
    width: { xs: "100%", md: "48%" },
    px: { xs: getResponsiveSize(3), sm: getResponsiveSize(4), md: 0 }, 
  },

  heading: {
    fontSize: { md: "25px", sm: "22px", xs: "20px" },
    fontFamily: globalStyles.fonts.primaryUAE,
    fontWeight: 600,
    lineHeight: { xs: "100%", md: "auto" },
    letterSpacing: "0.5px",
    marginTop: {
      xs: getResponsiveSize(2),
      sm: getResponsiveSize(3),
      md: getResponsiveSize(5),
    },
    marginBottom: { xs: getResponsiveSize(1), sm: getResponsiveSize(1), md: 0 },
    textTransform: "uppercase",
    textAlign: { xs: "center", sm: "center", md: "left" },
  },

  descriptionContainer: {
    marginTop: {
      xs: getResponsiveSize(2),
      sm: getResponsiveSize(3),
      md: getResponsiveSize(3),
    },
    paddingX: { xs: getResponsiveSize(3), sm: getResponsiveSize(4), md: 0 }, // horizontal space for xs & sm
  },

  description: {
    fontSize: { sm: "16px", xs: "14px" }, // balanced sizing
    color: "#666666",
    fontWeight: 400,
    letterSpacing: "0.3px",
    lineHeight: "170%",
    textAlign: { xs: "center", sm: "center", md: "left" }, // center on tablet
  },

  authorName: {
    fontSize: { sm: "20px", xs: "15px" },
    color: "#65BA0D",
    fontFamily: ' "Poppins", serif ',
    fontWeight: 600,
    marginTop: { xs: getResponsiveSize(2), sm: getResponsiveSize(3) },
    marginBottom: { xs: getResponsiveSize(1), sm: getResponsiveSize(1) },
    textAlign: { xs: "center", md: "left" },
  },
  authorTitle: {
    fontSize: { sm: "15px", xs: "12px" },
    color: "#003A26",
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    textAlign: { xs: "center", md: "left" },
  },
};
export default LaundryMan;
